import React from "react";
import { useContent } from "../context/ContentContext";
import { CampaignLogo } from "./sections";
import { Instagram, Facebook } from "lucide-react";

export default function Header() {
  const { content, updateHeader, editMode, isAdmin } = useContent();
  const h = content.header;
  const editing = editMode && isAdmin;

  const socials = [
    { key: "facebookUrl", label: "Facebook", Icon: Facebook },
    { key: "instagramUrl", label: "Instagram", Icon: Instagram },
  ];

  return (
    <header className="w-full">
      <div className="h-2 w-full" style={{ backgroundColor: content.theme.red }} />
      <div className="w-full px-6 py-8" style={{ backgroundColor: content.theme.navy }}>
        <div className="mx-auto flex max-w-5xl flex-col items-center gap-5">
          <a href="/" className="block">
            <CampaignLogo />
          </a>
          {(h.donateUrl || editing) && (
            <a
              data-testid="donate-btn"
              href={editing ? undefined : h.donateUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Donate (opens in new tab)"
              title={editing ? "Click to edit donate link" : "Donate"}
              onClick={(e) => {
                if (!editing) return;
                e.preventDefault();
                const url = window.prompt("Donate button link (leave blank to hide):", h.donateUrl || "https://");
                if (url !== null) updateHeader({ donateUrl: url.trim() === "https://" ? "" : url.trim() });
              }}
              className={`block w-44 transition-transform duration-200 hover:scale-105 md:w-52 ${
                editing && !h.donateUrl ? "opacity-40 outline-dashed outline-1 outline-white/60" : ""
              }`}
              style={{ filter: "drop-shadow(0 4px 10px rgba(0,0,0,0.3))" }}
            >
              <img src={h.donateImage || "/donate-button.png"} alt="Donate" className="h-auto w-full" />
            </a>
          )}
          <div className="flex items-center gap-3" data-testid="header-socials">
            {socials.map(({ key, label, Icon }) =>
              h[key] || editing ? (
                <a
                  key={key}
                  data-testid={`social-${label.toLowerCase()}-link`}
                  href={editing ? undefined : h[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${label} (opens in new tab)`}
                  title={editing ? `Click to edit ${label} link` : label}
                  onClick={(e) => {
                    if (!editing) return;
                    e.preventDefault();
                    const url = window.prompt(`${label} URL (leave blank to hide):`, h[key] || "https://");
                    if (url !== null) updateHeader({ [key]: url.trim() === "https://" ? "" : url.trim() });
                  }}
                  className={`flex h-11 w-11 items-center justify-center rounded-full bg-white/15 text-white transition-[background-color,transform] duration-200 hover:scale-110 hover:bg-white/30 ${
                    editing && !h[key] ? "opacity-40 outline-dashed outline-1 outline-white/60" : ""
                  }`}
                >
                  <Icon size={22} />
                </a>
              ) : null
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
